import { SignedChip } from '@dealstack/frontend/shared/components/Chips/CommonChips';
import styled from 'styled-components';

export const ContractWrapper = styled.div`
	max-width: 70rem;
`;

export const GeneratingContractsWrapper = styled.div`
	text-align: center;

	& > div:first-of-type {
		height: 10rem;
		position: relative;
	}
`;

export const StyledSignedChip = styled(SignedChip)`
	white-space: nowrap;
`;
